class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const facetDrawer = document.getElementById('FacetDrawer');
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }   
    if (countContainerMobile){
      countContainerMobile.classList.add('loading');
    } 
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }
    if (facetDrawer){
      facetDrawer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    document.dispatchEvent(new CustomEvent('collection:reloaded'));
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        document.dispatchEvent(new CustomEvent('collection:rendered_from_fetch'));
    })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    document.dispatchEvent(new CustomEvent('collection:rendered_from_cache'));
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    // Re-apply active layout to the freshly rendered grid. Prefer the currently visible switcher so mobile and desktop both work.
    const switchers = document.querySelectorAll('layout-switcher');
    for (const switcher of switchers) {
      if (switcher.offsetParent === null) continue;
      const active = switcher.querySelector('.list-view__item--active');
      if (active) {
        switcher.changeLayoutMode(active, active.dataset.layoutMode, false);
        break;
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetSortFiltersForm .js-filter, #FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements);
    const countsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element)).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    const facetDrawer = document.getElementById('FacetDrawer');
    if (facetDrawer) {
      facetDrawer.classList.remove('loading');
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.facets__open', '.sorting-desktop', '#FacetDrawer .facets__inner', '#FacetFiltersFormMobile .mobile-facets__inner'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('facet-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const searchParamsString = searchParams.toString();
    history.pushState({ searchParams: searchParamsString }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParamsString)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  mergeSearchParams(form, searchParams) {
    const params = this.createSearchParams(form);
    params.forEach((value, key) => {
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  mobileScrollToContet() {
    const mobileForm = document.querySelector('#FacetFiltersFormMobile');
    const container = mobileForm.querySelector('.mobile-facets__inner');
    const content = mobileForm.querySelector('.js-filter[data-index="4"]');
    const contentTop = content.offsetTop;

    container.scrollTo({
      top: contentTop,
      behavior: 'smooth'
    });
  }

  dimemnsionsAnimations(event) {
    if (event.target.name === 'filter.p.m.custom.table_shape') {
      const filtersContainer = event.target.closest('sticky-facet-filters');
      if (!filtersContainer.classList.contains('shape-selected')) {
        filtersContainer.classList.add('shape-selected', 'loading');
        this.mobileScrollToContet();
        setTimeout(() => {
          filtersContainer.classList.add('loaded');
          filtersContainer.classList.remove('loading');
        }, 300);
      }
      if (!event.target.checked) {
       const allInputs = event.target.closest('.js-filter').querySelectorAll('input');
       const checkedInputs = Array.from(allInputs).filter(input => input.checked);
       if (checkedInputs.length === 0) {
        filtersContainer.classList.add('unloading');
        setTimeout(() => {
          filtersContainer.classList.remove('shape-selected', 'loaded', 'unloading');
        }, 300);
       }
      }
    }
  }

  uncheckDimmensions(searchParams) {
    searchParams.delete('filter.p.m.custom.diameter');
    searchParams.delete('filter.p.m.custom.length');
    searchParams.delete('filter.p.m.custom.width');
    searchParams.delete('filter.p.m.custom.height');
    searchParams.delete('filter.p.m.custom.required_floor_space');

    return searchParams
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const currentForm = event.target.closest('form');
    if (currentForm.id === 'FacetFiltersFormMobile') {
      let searchParams = this.createSearchParams(currentForm);
      // uncheck dimmensions on selected shape change 
      if (event.target.name === 'filter.p.m.custom.table_shape' && !event.target.checked) {
        searchParams = this.uncheckDimmensions(searchParams)
      }
      this.dimemnsionsAnimations(event)
      this.onSubmitForm(searchParams, event);
    }
    else {
      let searchParams = new URLSearchParams();

      if (currentForm.id === 'FacetSortFiltersForm' && currentForm.dataset.filterType === 'drawer') {
        const mobileForm = document.getElementById('FacetFiltersFormMobile');
        searchParams = this.mergeSearchParams(mobileForm, searchParams);
        searchParams.delete('sort_by');
      }
  
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortFiltersForm') {
          searchParams = this.mergeSearchParams(form, searchParams);
        }
      });
     
      // uncheck dimmensions on selected shape change 
      if (event.target.name === 'filter.p.m.custom.table_shape' && !event.target.checked) {             
        searchParams = this.uncheckDimmensions(searchParams)
      }

      this.dimemnsionsAnimations(event)

      this.onSubmitForm(searchParams, event);
    }
    /*
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
    */
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

      if (event.currentTarget.dataset.param === 'filter.p.m.custom.table_shape') {
        this.removeShapeFilter(event)
      } else form.onActiveFilterClick(event); 
      
      if (event.currentTarget.classList.contains('facets__clear') || event.currentTarget.classList.contains('mobile-facets__clear')  || event.currentTarget.classList.contains('active-facets__button--dark')) {
        this.animation();
      }
    });
  }
  removeShapeFilter(event) {
    const clickedShape = event.currentTarget.dataset.value;
    const filtersContainer = document.getElementById('FacetDrawer');
    const input = filtersContainer.querySelector(`input[name="filter.p.m.custom.table_shape"][value="${clickedShape}"]`);
    if (input) {
      input.click();
    }
  }
  animation() {
    const filtersContainer = document.getElementById('main-facet-filters');
    filtersContainer.classList.add('unloading');
    setTimeout(() => {
      filtersContainer.classList.remove('shape-selected', 'loaded', 'unloading');
    }, 300);
  }
}
customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.min = Number(this.dataset.min);
    this.max = Number(this.dataset.max);
    this.track = this.querySelector(".price-range__track");
    this.handles = [...this.querySelectorAll(".price-range__thumbs")];
    this.startPos = 0;
    this.activeHandle;

    this.handles.forEach(handle => {
      handle.addEventListener("mousedown", this.startMove.bind(this));
      handle.addEventListener("touchstart", this.startMove.bind(this), { passive: true });
    });

    window.addEventListener("mouseup", this.stopMove.bind(this));
    window.addEventListener("touchend", this.stopMove.bind(this), { passive: true });

    this.querySelectorAll('input').forEach(
      element => element.addEventListener('change', this.onRangeChange.bind(this))
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  startMove(e) {
    e.preventDefault();
    this.startPos = e.type.includes("mouse") ? e.offsetX : e.touches[0].clientX - e.target.getBoundingClientRect().left;
    this.activeHandle = e.target;
    this.moveListener = this.move.bind(this);

    window.addEventListener("mousemove", this.moveListener);
    window.addEventListener("touchmove", this.moveListener, { passive: false });
  }

  move(e) {
    const isLower = this.activeHandle.classList.contains("is-lower");
    const property = isLower ? "--progress-lower" : "--progress-upper";
    const parentRect = this.track.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let newX;

    if (e.type.includes("mouse")) {
      newX = e.clientX - parentRect.x - this.startPos;
    } else {
      newX = e.touches[0].clientX - parentRect.x - this.startPos;
    }

    if (isLower) {
      const otherX = parseInt(this.style.getPropertyValue("--progress-upper"));
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.min(newX, percentageX - handleRect.width);
      newX = Math.max(newX, 0 - handleRect.width / 2);
    } else {
      const otherX = parseInt(this.style.getPropertyValue("--progress-lower"));
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.max(newX, percentageX);
      newX = Math.min(newX, parentRect.width - handleRect.width / 2);
    }

    const percentage = (newX + handleRect.width / 2) / parentRect.width;
    const valuenow = this.calcHandleValue(percentage);
    this.style.setProperty(property, percentage * 100 + "%");
    this.activeHandle.ariaValueNow = valuenow;

    const output = this.activeHandle.nextElementSibling;
    const text = output.querySelector('.price-range__output-text');
    text.innerHTML = valuenow;

    const inputs = this.querySelectorAll('input');
    const input = isLower ? inputs[0] : inputs[1];
    input.value = valuenow;

    this.adjustToValidValues(input);
    this.setMinAndMaxValues();
  }

  calcHandleValue(percentage) {
    return Math.round(percentage * (this.max - this.min) + this.min);
  }

  stopMove() {
    window.removeEventListener("mousemove", this.moveListener);
    window.removeEventListener("touchmove", this.moveListener);
    const form = this.closest('form');

    if (this.activeHandle && form) form.dispatchEvent(new Event('input'));
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class LayoutSwitcher extends HTMLElement {
	constructor() {
    super();

    this.storageNames = {
      mobile: 'beyours:collection-layout:mobile',
      desktop: 'beyours:collection-layout:desktop'
    };
    this.mediaQuery = window.matchMedia('(max-width: 989px)');
    this.onViewportChange = this.handleViewportChange.bind(this);

    this.initLayoutMode();
    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onViewportChange);
    } else {
      this.mediaQuery.addListener(this.onViewportChange);
    }
	}

  disconnectedCallback() {
    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.removeEventListener('change', this.onViewportChange);
    } else {
      this.mediaQuery.removeListener(this.onViewportChange);
    }
  }

  get storageName() {
    return this.dataset.mobile === 'true' ? this.storageNames.mobile : this.storageNames.desktop;
  }

  isActiveViewport() {
    return this.dataset.mobile === 'true' ? this.mediaQuery.matches : !this.mediaQuery.matches;
  }

  handleViewportChange() {
    window.requestAnimationFrame(() => {
      this.initLayoutMode();
      this.resetDesktopLayoutWithoutSwitcher();
    });
  }
	
  onButtonClick(event) {
    const eventTarget = event.target ? event.target : event;
    // Click can land on a child element (icon, label); resolve to the owning .list-view__item.
    const target = eventTarget.closest ? eventTarget.closest('.list-view__item') : eventTarget;
    if (!target || !target.dataset.layoutMode) return;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    // Only the visible switcher should mutate the shared #product-grid. A hidden switcher
    // (e.g. mobile markup on a desktop viewport) must defer to the visible one so it can't
    // bleed its stored mode across viewports.
    if (!this.isActiveViewport() || this.offsetParent === null) return;

    const layoutMode = isStorageSupported('session')
      ? window.sessionStorage.getItem(this.storageName)
      : null;

    if (layoutMode !== null) {
      const target = this.querySelector(`.list-view__item[data-layout-mode="${layoutMode}"]`);
      if (target) {
        this.changeLayoutMode(target, layoutMode, false);
        return;
      }
      // Stored mode isn't supported by this switcher (e.g. storage has grid-3 from desktop,
      // user is now on mobile which only has list + grid-2). Fall through to the rendered default.
    }

    const activeButton = this.querySelector('.list-view__item--active');
    if (activeButton && activeButton.dataset.layoutMode) {
      this.changeLayoutMode(activeButton, activeButton.dataset.layoutMode, false);
    }
  }

  changeLayoutMode(target, layoutMode, persist = true) {
    const productGrid = document.getElementById('product-grid');

    if (!productGrid || productGrid.classList.contains('collection--empty')) {
      return;
    }

    this.applyGridClasses(productGrid, layoutMode);

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.classList.remove('list-view__item--active')
    );

    target.classList.add('list-view__item--active');

    if (persist && isStorageSupported('session')) {
      window.sessionStorage.setItem(this.storageName, layoutMode);
    }
  }

  applyGridClasses(productGrid, layoutMode) {
    const removedClass = ['list', 'grid', 'grid--1-col', 'grid--1-col-mobile', 'grid--2-col', 'grid--3-col-tablet', 'grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop'];
    removedClass.forEach((removed) => {
      productGrid.classList.remove(removed);
    });

    let addedClass = [];
    switch (layoutMode) {
      case 'list':
        addedClass = ['grid', 'grid--1-col', 'grid--2-col-desktop', 'list'];
        break;

      case 'grid-2':
        addedClass = ['grid', 'grid--2-col'];
        break;

      case 'grid-3':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--3-col-desktop'];
        break;

      case 'grid-4':
        addedClass = ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--4-col-desktop'];
        break;
    }
    addedClass.forEach((added) => {
      productGrid.classList.add(added);
    });
  }

  resetDesktopLayoutWithoutSwitcher() {
    if (this.mediaQuery.matches || document.querySelector('layout-switcher:not([data-mobile="true"])')) return;

    const productGrid = document.getElementById('product-grid');
    const defaultLayout = productGrid ? productGrid.dataset.defaultLayout : null;
    if (!productGrid || !defaultLayout) return;

    this.applyGridClasses(productGrid, defaultLayout);
  }
}
customElements.define('layout-switcher', LayoutSwitcher);

class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.parentNode.offsetTop) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.classList.add('shopify-section-filters-sticky');
  }

  reset() {
    this.classList.remove('shopify-section-filters-sticky');
  }
}
customElements.define('sticky-facet-filters', StickyFacetFilters);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    const attributes = {
      expanded: 'aria-expanded'
    };

    const button = this.querySelector('.button-show-more');
    button.addEventListener('click', () => {
      const filter = this.closest('.js-filter');
      filter.setAttribute(
        attributes.expanded,
        (filter.getAttribute(attributes.expanded) === 'false').toString()
      );

      this.querySelectorAll('.visually-hidden').forEach(element => element.classList.toggle('hidden'));
    });
  }
}
customElements.define('show-more-button', ShowMoreButton);
